//@flow
import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';

import RewardsContainer from '../rewards/RewardsContainer';
import LoyaltyModulesContainer from '../loyaltyModules/LoyaltyModulesContainer';

import { setupDeepLinkHandler } from '../helpers';

import '../rewards/rewards.scss';

const locale = serverVars.get('localeDataKey');
const messages = serverVars.get('messages');

const QUERY_RENDERER_COUNT = 2;

initializeDBL().then(() => {
    if (window.ReactIntlLocaleData) {
        addLocaleData(window.ReactIntlLocaleData[locale]);
    }

    const linkHandler = setupDeepLinkHandler(QUERY_RENDERER_COUNT);

    const Rewards = React.createElement(RewardsContainer, linkHandler);
    const LoyaltyModules = React.createElement(LoyaltyModulesContainer, linkHandler);

    const rewardsDOMNode = document.getElementById('rewardsContent');
    if (rewardsDOMNode) {
        ReactDOM.render(
            React.createElement(IntlProvider, { locale, messages }, Rewards),
            rewardsDOMNode
        );
    }

    const loyatlyModulesDOMNode = document.getElementById('loyaltyModulesContainer');
    if (loyatlyModulesDOMNode) {
        ReactDOM.render(
            React.createElement(IntlProvider, { locale, messages }, LoyaltyModules),
            loyatlyModulesDOMNode
        );
    }
});
